import { Input, Select } from 'antd';
import SwitchButton from '../LoanProduct/SwitchButton';
import { useContext } from 'react';
import { ProductInfoContext } from '.';

const FloatHeaderFilter = (props) => {
  const {
    interestCatg,
    filterItem,
    setFilterItem,
    comYearPos,
    setComYearPos,
    handleSwitchButton,
  } = props.context;
  return (
    <div className='fixed top-0 right-0 s_Filt_w bg-white px-[20px] pt-[13px] z-[90] shadow-lg'>
      <h3 className='text-[#27272B] text-[14px] mb-[15px] font-[700]'>
        Select year of commission
      </h3>
      <div className='flex justify-between gap-[25px]'>
        <div className='scBarHidden overflow-x-scroll'>
          <div className='w-[550px]'>
            {Array.from({ length: 10 }).map((_, idx) => {
              return (
                <span
                  key={idx}
                  className={`select-none inline-block border border-[#C3D2E2] text-[12px]  p-[6px_17px] cursor-pointer rounded-[4px] mr-[10px] mb-[10px] ${
                    idx === Number(comYearPos)
                      ? 'bg-[#0F59F9] text-white'
                      : 'text-[#263238]'
                  }`}
                  onClick={() => setComYearPos(idx)}
                >
                  {idx + 1}
                </span>
              );
            })}
          </div>
        </div>
        <SwitchButton
          noFloat
          switchVal={interestCatg}
          handleSwitchButton={handleSwitchButton}
        />
      </div>
      <div className='flex items-center  mt-[8px] flex-wrap max-w-[525px] mb-[18px] gap-[10px]'>
        <div className='flex items-center'>
          <Input
            prefix={
              <img src='/images/search.svg' alt='search' className='mr-[5px]' />
            }
            placeholder='Search By Agent, Comm'
            value={filterItem.keyword}
            onChange={(e) =>
              setFilterItem({ ...filterItem, keyword: e.target.value })
            }
            className='loan_com_search flotHead w-[255px] max-[600px]:w-full'
            style={{ boxShadow: 'none' }}
          />
        </div>
        <div className='max-[600px]:w-[50%]'>
          <div className='flex items-center'>
            <Select
              className='loan_com_select isBorder min-w-[255px] max-w-full'
              value={filterItem.sortOrder}
              onChange={(val) =>
                setFilterItem({ ...filterItem, sortOrder: val })
              }
              suffixIcon={
                <img
                  src='/images/select_ar.svg'
                  alt='arrow'
                  className='mr-[6px]'
                />
              }
              options={[
                {
                  value: 'desc',
                  label: 'Loan Comm. (High - Low)',
                },
                {
                  value: 'asc',
                  label: 'Loan Comm. (Low - High)',
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatHeaderFilter;
